<form [formGroup]="hulpmiddelen">
    <div formArrayName="pgaHulpmiddelen">
        <div *ngFor="let item of pgaHulpmiddelen.controls; let i = index; "
             [formGroupName]="i" class="row">

            <snelstart-ui-text-form-control (change)="saveForm()"
                                            [label]="i === 0 ? 'Hulpmiddellen' : ''"
                                            class="col-auto custom-input-250"
                                            formControlName="omschrijving"
                                            id="omschrijving"
            >

            </snelstart-ui-text-form-control>
            <snelstart-ui-number-form-control (change)="saveForm()"
                                              [decimals]="0"
                                              [label]="i === 0 ? 'Bedrag' : ''"
                                              [required]=true
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="bedrag"
                                              id="bedrag"
                                              prefix="€"

            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-button (click)="verwijderRijHulpmiddelen(i)"
                                 [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                                 iconType="light"
                                 id="buttonDeleteKosten"
                                 icon="trash"
                                 size="medium"
                                 type="secondary"
            >
            </snelstart-ui-button>
        </div>
    </div>
</form>

<div *ngIf="pgaHulpmiddelen.length === 0">
    <snelstart-ui-button (click)="addRijHulpmiddelen()" class="snelstart-ui-button pb-3" icon="plus"
                         type="link">Hulpmiddel
    </snelstart-ui-button>
</div>
<div *ngIf="pgaHulpmiddelen.length > 0">
    <snelstart-ui-button (click)="addRijHulpmiddelen()" class="snelstart-ui-button pb-3" icon="plus"
                         type="link">Hulpmiddel toevoegen
    </snelstart-ui-button>
</div>



